(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("react-select"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "react-select", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["Auth0LockPlayground"] = factory(require("react"), require("prop-types"), require("react-select"), require("lodash"));
	else
		root["Auth0LockPlayground"] = factory(root["react"], root["prop-types"], root["react-select"], root["lodash"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_43__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 41);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LanguageSelector = exports.OptionSelector = exports.EditorOption = exports.Editor = exports.CodePenButton = exports.MultiSelector = exports.FooterLinks = exports.Preview = exports.default = undefined;

var _LockPlayground = __webpack_require__(32);

var _LockPlayground2 = _interopRequireDefault(_LockPlayground);

var _Preview2 = __webpack_require__(40);

var _Preview3 = _interopRequireDefault(_Preview2);

var _FooterLinks2 = __webpack_require__(6);

var _FooterLinks3 = _interopRequireDefault(_FooterLinks2);

var _MultiSelector2 = __webpack_require__(35);

var _MultiSelector3 = _interopRequireDefault(_MultiSelector2);

var _CodePenButton2 = __webpack_require__(4);

var _CodePenButton3 = _interopRequireDefault(_CodePenButton2);

var _Editor2 = __webpack_require__(5);

var _Editor3 = _interopRequireDefault(_Editor2);

var _EditorOption2 = __webpack_require__(3);

var _EditorOption3 = _interopRequireDefault(_EditorOption2);

var _OptionSelector2 = __webpack_require__(7);

var _OptionSelector3 = _interopRequireDefault(_OptionSelector2);

var _LanguageSelector2 = __webpack_require__(30);

var _LanguageSelector3 = _interopRequireDefault(_LanguageSelector2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LockPlayground2.default;
exports.Preview = _Preview3.default;
exports.FooterLinks = _FooterLinks3.default;
exports.MultiSelector = _MultiSelector3.default;
exports.CodePenButton = _CodePenButton3.default;
exports.Editor = _Editor3.default;
exports.EditorOption = _EditorOption3.default;
exports.OptionSelector = _OptionSelector3.default;
exports.LanguageSelector = _LanguageSelector3.default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ColorOption = exports.LogoOption = exports.SocialButtonStyle = exports.LanguageOption = exports.LanguageDictionaryOption = exports.InitialScreenOption = exports.EditorOption = exports.ConnectionOption = exports.BooleanOption = exports.AdditionalSignUpFieldsOption = exports.default = undefined;

var _EditorOption2 = __webpack_require__(21);

var _EditorOption3 = _interopRequireDefault(_EditorOption2);

var _AdditionalSignUpFieldsOption2 = __webpack_require__(17);

var _AdditionalSignUpFieldsOption3 = _interopRequireDefault(_AdditionalSignUpFieldsOption2);

var _BooleanOption2 = __webpack_require__(18);

var _BooleanOption3 = _interopRequireDefault(_BooleanOption2);

var _ConnectionOption2 = __webpack_require__(20);

var _ConnectionOption3 = _interopRequireDefault(_ConnectionOption2);

var _InitialScreenOption2 = __webpack_require__(22);

var _InitialScreenOption3 = _interopRequireDefault(_InitialScreenOption2);

var _LanguageDictionaryOption2 = __webpack_require__(23);

var _LanguageDictionaryOption3 = _interopRequireDefault(_LanguageDictionaryOption2);

var _LanguageOption2 = __webpack_require__(24);

var _LanguageOption3 = _interopRequireDefault(_LanguageOption2);

var _SocialButtonStyle2 = __webpack_require__(26);

var _SocialButtonStyle3 = _interopRequireDefault(_SocialButtonStyle2);

var _LogoOption2 = __webpack_require__(25);

var _LogoOption3 = _interopRequireDefault(_LogoOption2);

var _ColorOption2 = __webpack_require__(19);

var _ColorOption3 = _interopRequireDefault(_ColorOption2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EditorOption3.default;
exports.AdditionalSignUpFieldsOption = _AdditionalSignUpFieldsOption3.default;
exports.BooleanOption = _BooleanOption3.default;
exports.ConnectionOption = _ConnectionOption3.default;
exports.EditorOption = _EditorOption3.default;
exports.InitialScreenOption = _InitialScreenOption3.default;
exports.LanguageDictionaryOption = _LanguageDictionaryOption3.default;
exports.LanguageOption = _LanguageOption3.default;
exports.SocialButtonStyle = _SocialButtonStyle3.default;
exports.LogoOption = _LogoOption3.default;
exports.ColorOption = _ColorOption3.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CodePenIcon = exports.default = undefined;

var _CodePenButton = __webpack_require__(11);

var _CodePenButton2 = _interopRequireDefault(_CodePenButton);

var _CodePenIcon2 = __webpack_require__(12);

var _CodePenIcon3 = _interopRequireDefault(_CodePenIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CodePenButton2.default;
exports.CodePenIcon = _CodePenIcon3.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EditorAndroid = exports.EditoriOS = exports.EditorWeb = exports.default = undefined;

var _Editor = __webpack_require__(13);

var _Editor2 = _interopRequireDefault(_Editor);

var _EditorWeb2 = __webpack_require__(15);

var _EditorWeb3 = _interopRequireDefault(_EditorWeb2);

var _EditoriOS2 = __webpack_require__(16);

var _EditoriOS3 = _interopRequireDefault(_EditoriOS2);

var _EditorAndroid2 = __webpack_require__(14);

var _EditorAndroid3 = _interopRequireDefault(_EditorAndroid2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Editor2.default;
exports.EditorWeb = _EditorWeb3.default;
exports.EditoriOS = _EditoriOS3.default;
exports.EditorAndroid = _EditorAndroid3.default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ReadIcon = exports.default = undefined;

var _FooterLinks = __webpack_require__(27);

var _FooterLinks2 = _interopRequireDefault(_FooterLinks);

var _ReadIcon2 = __webpack_require__(28);

var _ReadIcon3 = _interopRequireDefault(_ReadIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FooterLinks2.default;
exports.ReadIcon = _ReadIcon3.default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.IcoOption = exports.IcoValue = exports.default = undefined;

var _OptionSelector = __webpack_require__(38);

var _OptionSelector2 = _interopRequireDefault(_OptionSelector);

var _IcoValue2 = __webpack_require__(37);

var _IcoValue3 = _interopRequireDefault(_IcoValue2);

var _IcoOption2 = __webpack_require__(36);

var _IcoOption3 = _interopRequireDefault(_IcoOption2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _OptionSelector2.default;
exports.IcoValue = _IcoValue3.default;
exports.IcoOption = _IcoOption3.default;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("react-select");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CodePenButton = function CodePenButton(_ref) {
  var optionsString = _ref.optionsString;

  var js = 'var lock = new Auth0Lock(\n  "YOUR_CLIENT_ID",\n  "YOUR_AUTH0_DOMAIN",\n  {\n    ' + optionsString + '\n  }\n);\n\nlock.show();\n';
  var data = JSON.stringify({
    title: 'Auth0 Lock',
    description: 'Auth0 Lock example. Created from https://auth0.com.',
    editors: '001', // HTML, CSS, JS
    layout: 'left', // top, left, right
    // eslint-disable-next-line max-len
    head: '<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />',
    js: js,
    js_external: 'https://cdn.auth0.com/js/lock/10.16.0/lock.min.js' // semi-colon separate multiple files
  });

  return _react2.default.createElement(
    'form',
    { target: '_blank', action: 'https://codepen.io/pen/define', method: 'POST' },
    _react2.default.createElement('input', { type: 'hidden', name: 'data', value: data }),
    _react2.default.createElement(
      'button',
      null,
      _react2.default.createElement(_.CodePenIcon, null),
      _react2.default.createElement(
        'span',
        null,
        'Edit on codepen'
      )
    )
  );
};

CodePenButton.propTypes = {
  optionsString: _propTypes2.default.string.isRequired
};

exports.default = CodePenButton;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CodePenIcon = function CodePenIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "256px", height: "256px", viewBox: "0 0 256 256", preserveAspectRatio: "xMinYMin meet" },
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "M255.806943,87.0866439 C255.748337,86.7763743 255.696625,86.4661047 255.613887,86.1627299 C255.562175,85.9800156 255.500121,85.8076436 255.441515,85.6283767 C255.355329,85.3594764 255.265695,85.0905761 255.158825,84.8285707 C255.082981,84.6458563 254.996795,84.4700369 254.914056,84.2942175 C254.796843,84.0460018 254.676183,83.8012335 254.538285,83.5633602 C254.441757,83.3875407 254.331439,83.2220636 254.224568,83.0531391 C254.076328,82.825608 253.924641,82.6015244 253.759164,82.3843357 C253.638504,82.222306 253.514396,82.0671712 253.383393,81.9120364 C253.211021,81.70519 253.024859,81.5086859 252.838698,81.3156293 C252.693905,81.1708368 252.549113,81.0260443 252.397425,80.8846993 C252.197474,80.701985 251.990627,80.529613 251.773439,80.3641359 C251.607961,80.2365806 251.445932,80.1055779 251.27356,79.9883649 C251.211506,79.9435482 251.156347,79.8918366 251.090845,79.8504673 L134.098521,1.8486897 C130.406313,-0.616229901 125.590239,-0.616229901 121.898031,1.8486897 L4.89881225,79.8470198 C4.83331089,79.8883891 4.78159929,79.9401007 4.71609793,79.9849174 C4.54372593,80.1055779 4.38169625,80.2331331 4.21621913,80.3606884 C4.00247785,80.529613 3.79218401,80.701985 3.59223249,80.8778044 C3.44054513,81.015702 3.29575265,81.1604945 3.15440761,81.3087344 C2.96135097,81.5017911 2.78208409,81.6982951 2.60626464,81.9051415 C2.47526192,82.0602763 2.35115408,82.2154111 2.23049368,82.3877831 C2.06501656,82.6049719 1.9133292,82.825608 1.76508928,83.0565865 C1.65821864,83.2255111 1.551348,83.3909882 1.45137224,83.5668076 C1.31347464,83.804681 1.19281424,84.0494492 1.07904872,84.29077 C0.996310162,84.4665895 0.906676722,84.6458563 0.834280482,84.8251232 C0.727409841,85.0871287 0.634328961,85.356029 0.548142961,85.6249293 C0.489536481,85.8041962 0.427482561,85.9800156 0.379218401,86.1420453 C0.299927281,86.44542 0.2413208,86.7522422 0.18616176,87.0659592 C0.1551348,87.2245415 0.11721296,87.3796763 0.0965283202,87.5417059 C0.0344744001,88.0174527 2.84217094e-14,88.4931994 2.84217094e-14,88.9792884 L2.84217094e-14,166.994856 C2.84217094e-14,167.477497 0.0344744001,167.960139 0.1034232,168.432438 C0.12755528,168.60481 0.172372,168.742708 0.2068464,168.908185 C0.26200544,169.218455 0.310269601,169.528724 0.413692801,169.838994 C0.461956961,170.011366 0.517116001,170.183738 0.586064801,170.373347 C0.672250801,170.649142 0.758436801,170.924937 0.861860002,171.176601 C0.934256242,171.348973 1.034232,171.521345 1.1031808,171.693717 C1.21694632,171.935037 1.3445016,172.176358 1.4823992,172.428021 C1.57892752,172.600393 1.6892456,172.772765 1.7926688,172.931347 C1.94090872,173.172668 2.1029384,173.379515 2.2753104,173.586361 C2.3959708,173.758733 2.5166312,173.896631 2.6545288,174.062108 C2.83034825,174.268954 2.99927281,174.475801 3.20611921,174.658515 C3.34746425,174.796413 3.48191441,174.968785 3.65428641,175.072208 C3.85423793,175.24458 4.06797921,175.416952 4.27482561,175.596219 C4.44030273,175.734116 4.61956961,175.837539 4.75746721,175.97199 C4.82296857,176.006464 4.86089041,176.075413 4.92983921,176.10644 L121.898031,254.146139 C123.745859,255.387218 125.862587,256.007757 128,255.997414 C130.137413,255.987072 132.254141,255.376875 134.101969,254.146139 L251.101188,176.147809 C251.166689,176.10644 251.221848,176.058176 251.283902,176.013359 C251.456274,175.892698 251.618304,175.765143 251.783781,175.637588 C251.997522,175.468663 252.207816,175.292844 252.407768,175.113577 C252.559455,174.979127 252.704247,174.830887 252.84904,174.686094 C253.038649,174.493038 253.221363,174.296534 253.393735,174.089687 C253.524738,173.934553 253.648846,173.779418 253.769506,173.613941 C253.934983,173.396752 254.086671,173.172668 254.234911,172.945137 C254.341781,172.77966 254.448652,172.610736 254.548628,172.441811 C254.686525,172.20049 254.807186,171.955722 254.924399,171.707506 C255.007137,171.531687 255.093323,171.355867 255.169167,171.176601 C255.276038,170.911148 255.365671,170.642247 255.451857,170.373347 C255.510464,170.19408 255.572517,170.018261 255.624229,169.838994 C255.70352,169.535619 255.758679,169.225349 255.817286,168.91508 C255.844865,168.756498 255.886234,168.601363 255.903472,168.439333 C255.965526,167.963586 256,167.48784 256,167.001751 L256,88.9999731 C256,88.513884 255.962078,88.0381373 255.903472,87.5623906 C255.875892,87.393466 255.824181,87.2555684 255.789706,87.0866439 L255.806943,87.0866439 Z M127.996553,154.022139 L89.0921921,128.000862 L127.996553,101.976137 L166.90436,128.000862 L127.996553,154.022139 L127.996553,154.022139 Z M116.999219,82.8669773 L69.3073339,114.76614 L30.8097713,89.0137628 L116.999219,31.5552802 L116.999219,82.8669773 L116.999219,82.8669773 Z M49.5224757,127.997414 L22.0050096,146.403297 L22.0050096,109.591532 L49.5224757,127.997414 L49.5224757,127.997414 Z M69.3073339,141.242479 L116.999219,173.138194 L116.999219,224.449891 L30.8097713,166.984513 L69.3073339,141.235584 L69.3073339,141.242479 Z M138.997334,173.131299 L186.689219,141.235584 L225.190229,166.984513 L138.997334,224.442996 L138.997334,173.131299 L138.997334,173.131299 Z M206.474077,128.004309 L233.99499,109.59498 L233.99499,146.410191 L206.474077,127.997414 L206.474077,128.004309 Z M186.689219,114.76614 L138.997334,82.8704247 L138.997334,31.5552802 L225.190229,89.0137628 L186.689219,114.76614 L186.689219,114.76614 Z", fill: "white" })
    )
  );
}; /* eslint-disable max-len */
exports.default = CodePenIcon;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(2);

var _ = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var docsUrlList = ['https://auth0.com/docs/libraries/lock', 'https://auth0.com/docs/libraries/lock-ios', 'https://auth0.com/docs/libraries/lock-android'];

var Editor = function Editor(_ref) {
  var selectedLanguageIndex = _ref.selectedLanguageIndex,
      onOptionChange = _ref.onOptionChange,
      options = _ref.options,
      defaultColor = _ref.defaultColor,
      logos = _ref.logos,
      optionsString = _ref.optionsString;

  var editorProps = { onOptionChange: onOptionChange, options: options, logos: logos, defaultColor: defaultColor };
  var editorTypesList = [_react2.default.createElement(_.EditorWeb, editorProps), _react2.default.createElement(_.EditoriOS, editorProps), _react2.default.createElement(_.EditorAndroid, editorProps)];

  return _react2.default.createElement(
    'div',
    { className: 'editor' },
    _react2.default.createElement(
      'div',
      { className: 'code' },
      editorTypesList[selectedLanguageIndex],
      _react2.default.createElement('img', {
        src: 'https://cdn.auth0.com/website/playground/others/mobile-lock-example.svg',
        className: 'phone-example',
        alt: 'Phone with lock example'
      })
    ),
    _react2.default.createElement(_components.FooterLinks, {
      docsUrl: docsUrlList[selectedLanguageIndex],
      optionsString: optionsString
    })
  );
};

Editor.propTypes = {
  selectedLanguageIndex: _propTypes2.default.number.isRequired,
  onOptionChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.array.isRequired,
  preset: _propTypes2.default.string.isRequired,
  logoBaseUrl: _propTypes2.default.string,
  defaultColor: _propTypes2.default.string,
  logos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string.isRequired
  }).isRequired),
  hideName: _propTypes2.default.bool,
  optionsString: _propTypes2.default.string.isRequired
};

exports.default = Editor;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditorOption = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOptionsValue = function getOptionsValue(options, value) {
  return options.find(function (opt) {
    return opt[0] === value;
  })[1];
};

var EditorAndroid = function EditorAndroid(_ref) {
  var onOptionChange = _ref.onOptionChange,
      options = _ref.options;
  return _react2.default.createElement(
    'ol',
    { className: 'code-container' },
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'Auth0 account = new Auth0("cid", "domain");'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'Lock lock = Lock.newBuilder(account, new LockCallback() {…})'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        '.allowedConnections(Arrays.asList('
      ),
      _react2.default.createElement(_EditorOption.ConnectionOption, {
        value: getOptionsValue(options, 'allowedConnections'),
        onChange: onOptionChange
      }),
      _react2.default.createElement(
        'span',
        null,
        '))'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        '.build(this);'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'startActivity(lock.newIntent(this));'
      )
    )
  );
};

EditorAndroid.propTypes = {
  onOptionChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.array.isRequired,
  logos: _propTypes2.default.array,
  defaultColor: _propTypes2.default.string
};

exports.default = EditorAndroid;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditorOption = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOptionsValue = function getOptionsValue(options, value) {
  return options.find(function (opt) {
    return opt[0] === value;
  })[1];
};

var EditorWeb = function EditorWeb(_ref) {
  var onOptionChange = _ref.onOptionChange,
      options = _ref.options,
      logos = _ref.logos,
      defaultColor = _ref.defaultColor;
  return _react2.default.createElement(
    'ol',
    { className: 'code-container' },
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'var lock = new Auth0Lock(cid, domain, {'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        'allowedConnections: '
      ),
      _react2.default.createElement(_EditorOption.ConnectionOption, {
        value: getOptionsValue(options, 'allowedConnections'),
        onChange: onOptionChange
      })
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        'language:'
      ),
      _react2.default.createElement(_EditorOption.LanguageOption, {
        value: getOptionsValue(options, 'language'),
        onChange: onOptionChange
      })
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        'theme: {'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-2' },
      _react2.default.createElement(
        'span',
        null,
        'logo:'
      ),
      _react2.default.createElement(_EditorOption.LogoOption, {
        value: getOptionsValue(options, 'logo'),
        onChange: onOptionChange,
        logos: logos
      })
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-2' },
      _react2.default.createElement(
        'span',
        null,
        'primaryColor: '
      ),
      _react2.default.createElement(_EditorOption.ColorOption, {
        value: getOptionsValue(options, 'primaryColor'),
        onChange: onOptionChange,
        defaultColor: defaultColor
      })
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        '}'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        '});'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'lock.show();'
      )
    )
  );
};

EditorWeb.propTypes = {
  onOptionChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.array.isRequired,
  logos: _propTypes2.default.array,
  defaultColor: _propTypes2.default.string
};

exports.default = EditorWeb;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditorOption = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOptionsValue = function getOptionsValue(options, value) {
  return options.find(function (opt) {
    return opt[0] === value;
  })[1];
};

var EditoriOS = function EditoriOS(_ref) {
  var onOptionChange = _ref.onOptionChange,
      options = _ref.options,
      logos = _ref.logos,
      defaultColor = _ref.defaultColor;
  return _react2.default.createElement(
    'ol',
    { className: 'code-container' },
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'Lock'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        '.classic(clientId: "cid", domain: "domain")'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        '.allowedConnections('
      ),
      _react2.default.createElement(_EditorOption.ConnectionOption, {
        value: getOptionsValue(options, 'allowedConnections'),
        onChange: onOptionChange
      }),
      _react2.default.createElement(
        'span',
        null,
        ')'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        '.withStyle {'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-2' },
      _react2.default.createElement(
        'span',
        null,
        '$0.logo = LazyImage(name:'
      ),
      _react2.default.createElement(_EditorOption.LogoOption, {
        value: getOptionsValue(options, 'logo'),
        onChange: onOptionChange,
        logos: logos
      }),
      _react2.default.createElement(
        'span',
        null,
        ')'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-2' },
      _react2.default.createElement(
        'span',
        null,
        '$0.primaryColor = UIColor('
      ),
      _react2.default.createElement(_EditorOption.ColorOption, {
        value: getOptionsValue(options, 'primaryColor'),
        onChange: onOptionChange,
        defaultColor: defaultColor
      }),
      _react2.default.createElement(
        'span',
        null,
        ')'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        '}'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row indent-1' },
      _react2.default.createElement(
        'span',
        null,
        '.present(from: viewController)'
      )
    )
  );
};

EditoriOS.propTypes = {
  onOptionChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.array.isRequired,
  logos: _propTypes2.default.array,
  defaultColor: _propTypes2.default.string
};

exports.default = EditoriOS;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdditionalSignUpFieldsOption = function AdditionalSignUpFieldsOption() {
  var value = undefined.props.value;
  // NOTE: just handling one case for now is enough

  var _value$ = value[0],
      icon = _value$.icon,
      name = _value$.name,
      options = _value$.options,
      placeholder = _value$.placeholder,
      type = _value$.type,
      validator = _value$.validator;


  var typeRow = type === 'select' && _react2.default.createElement(
    'li',
    { className: 'line-row' },
    _react2.default.createElement(
      'span',
      null,
      'type: "select"'
    )
  );

  var validatorRow = validator && _react2.default.createElement(
    'li',
    { className: 'line-row' },
    _react2.default.createElement(
      'span',
      null,
      'validator: ',
      validator.toString()
    )
  );

  var optionsRow = options && _react2.default.createElement(
    'div',
    { className: 'line-row' },
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'options: ',
        '{'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'line-row' },
      options.map(function (x) {
        return _react2.default.createElement(
          'li',
          { className: 'line-row' },
          _react2.default.createElement(
            'span',
            null,
            '{',
            'label: "',
            x.label,
            '", value: "',
            x.value,
            '"',
            '}'
          )
        );
      })
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        '}'
      )
    )
  );

  return _react2.default.createElement(
    'div',
    { className: 'line-row' },
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'additionalSignUpFields: [',
        '{'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'name: "',
        name,
        '"'
      )
    ),
    typeRow,
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'placeholder: "',
        placeholder,
        '"'
      )
    ),
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        'icon: "',
        icon,
        '"'
      )
    ),
    optionsRow,
    validatorRow,
    _react2.default.createElement(
      'li',
      { className: 'line-row' },
      _react2.default.createElement(
        'span',
        null,
        '}',
        ']'
      )
    )
  );
};

AdditionalSignUpFieldsOption.propTypes = {
  value: _propTypes2.default.array.isRequired
};

exports.default = AdditionalSignUpFieldsOption;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BooleanOption = function BooleanOption(_ref) {
  var name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value;

  var values = [{ value: true, label: 'true' }, { value: false, label: 'false' }];

  return _react2.default.createElement(
    'li',
    { className: 'line-row' },
    _react2.default.createElement(
      'span',
      null,
      name,
      ':',
      _react2.default.createElement(_components.OptionSelector, {
        name: name,
        onChange: onChange,
        options: values,
        value: value
      })
    )
  );
};

BooleanOption.propTypes = {
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.bool.isRequired
};

exports.default = BooleanOption;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorOption = function (_Component) {
  _inherits(ColorOption, _Component);

  function ColorOption() {
    var _temp, _this, _ret;

    _classCallCheck(this, ColorOption);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function (name, value) {
      _this.props.onChange('primaryColor', value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ColorOption.prototype.render = function render() {
    var _props = this.props,
        value = _props.value,
        defaultColor = _props.defaultColor;


    var primaryColorValues = [{ value: 'default', label: 'default', bg: defaultColor || '#EA5323' }, { value: '#3A99D8', label: '#3A99D8', bg: '#3A99D8' }, { value: '#EC4889', label: '#EC4889', bg: '#EC4889' }, { value: '#40DF7D', label: '#40DF7D', bg: '#40DF7D' }];

    return _react2.default.createElement(_components.OptionSelector, {
      name: 'primaryColor',
      onChange: this.onChange,
      options: primaryColorValues,
      value: value
    });
  };

  return ColorOption;
}(_react.Component);

ColorOption.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired,
  defaultColor: _propTypes2.default.string
};
exports.default = ColorOption;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Auth0Icon = function Auth0Icon() {
  return _react2.default.createElement(
    'div',
    { className: 'connection-option-item' },
    _react2.default.createElement(
      'svg',
      { width: '15px', height: '16px', viewBox: '0 0 15 16', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement('path', { d: 'M11.2110917,12.9436339 L9.62622483,7.99976169 L13.7748138,4.94511138 L8.64671124,4.94511138 L7.06165623,0.0014298566 L7.06118595,9.53237733e-05 L12.190135,9.53237733e-05 L13.7754722,4.94463476 L13.7754722,4.94453944 L13.776789,4.94377685 C14.6976108,7.81225983 13.7493242,11.0748113 11.2110917,12.9436339 L11.2110917,12.9436339 L11.2110917,12.9436339 Z M2.91203263,12.9436339 L2.91071583,12.9445871 L7.06043349,16 L11.2110917,12.9437292 L7.06175029,9.88822096 L2.91203263,12.9436339 L2.91203263,12.9436339 Z M0.347181866,4.94387217 L0.347181866,4.94387217 C-0.621985404,7.96763758 0.503034949,11.1716602 2.91118611,12.9442058 L2.91156234,12.9426806 L4.49661735,7.99909442 L0.348874899,4.94501606 L5.47575471,4.94501606 L7.06090378,0.00133453282 L7.06128,0 L1.93204876,0 L0.347181866,4.94387217 L0.347181866,4.94387217 Z', id: 'Shape', stroke: 'none', fill: '#FFFFFF', fillRule: 'evenodd' })
    ),
    _react2.default.createElement(
      'span',
      { className: 'connection-option-text' },
      'Auth0'
    )
  );
};

var FacebookIcon = function FacebookIcon() {
  return _react2.default.createElement(
    'div',
    { className: 'connection-option-item' },
    _react2.default.createElement(
      'svg',
      { width: '16px', height: '16px', viewBox: '0 1 16 16', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'g',
        { id: 'F_icon', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(0.000000, 1.000000)' },
        _react2.default.createElement(
          'g',
          { id: 'Layer_1', fill: '#FFFFFF' },
          _react2.default.createElement('path', { d: 'M15.0784247,15.9571892 C15.5636139,15.9571892 15.9570656,15.5637375 15.9570656,15.0784247 L15.9570656,0.915027027 C15.9570656,0.42965251 15.5636757,0.0363243243 15.0784247,0.0363243243 L0.915027027,0.0363243243 C0.42965251,0.0363243243 0.0363243243,0.42965251 0.0363243243,0.915027027 L0.0363243243,15.0784247 C0.0363243243,15.5636757 0.429590734,15.9571892 0.915027027,15.9571892 L15.0784247,15.9571892 Z M11.0214054,15.9571892 L11.0214054,9.7917529 L13.0908417,9.7917529 L13.4007104,7.38897297 L11.0214054,7.38897297 L11.0214054,5.85494981 C11.0214054,5.15928958 11.2145792,4.68522008 12.212139,4.68522008 L13.4844788,4.68466409 L13.4844788,2.53559846 C13.2644324,2.5063166 12.5091583,2.44089575 11.6304556,2.44089575 C9.79601544,2.44089575 8.54010811,3.56064865 8.54010811,5.61698842 L8.54010811,7.38897297 L6.46535907,7.38897297 L6.46535907,9.7917529 L8.54010811,9.7917529 L8.54010811,15.9571892 L11.0214054,15.9571892 Z', id: 'Combined-Shape' })
        )
      )
    ),
    _react2.default.createElement(
      'span',
      { className: 'connection-option-text' },
      'Facebook'
    )
  );
};

var TwitterIcon = function TwitterIcon() {
  return _react2.default.createElement(
    'div',
    { className: 'connection-option-item' },
    _react2.default.createElement(
      'svg',
      { width: '18px', height: '15px', viewBox: '0 0 18 15', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement('path', { d: 'M15.5845818,4.0192 C15.5845818,3.86523345 15.5814458,3.71196509 15.5745396,3.55938909 C16.2691142,3.05726836 16.8728087,2.43066182 17.3489687,1.71735273 C16.7115869,2.00066327 16.0256815,2.19138327 15.3061469,2.27738182 C16.040576,1.83698618 16.604416,1.14033455 16.8704233,0.309847273 C16.1831215,0.717300364 15.4219869,1.01344 14.6115724,1.17332364 C13.9624378,0.481890909 13.0382778,0.0494254545 12.014976,0.0494254545 C10.0505251,0.0494254545 8.45750691,1.64250182 8.45750691,3.60619636 C8.45750691,3.88534109 8.48871564,4.156864 8.54974836,4.41730909 C5.59323927,4.268544 2.97162473,2.85303273 1.21709382,0.700654545 C0.911592727,1.22635055 0.735435636,1.83700364 0.735435636,2.48858182 C0.735435636,3.72273455 1.36345018,4.81224727 2.31844655,5.44962909 C1.73482473,5.43159738 1.18657745,5.27138909 0.707392,5.00472436 C0.706868364,5.01964916 0.706868364,5.03419985 0.706868364,5.05015098 C0.706868364,6.77291462 1.93305018,8.21128553 3.56074473,8.53722007 C3.26182982,8.61870953 2.94733382,8.66240407 2.62273745,8.66240407 C2.39387345,8.66240407 2.17089745,8.6398784 1.95417018,8.5982528 C2.40704582,10.0116637 3.72027927,11.0402019 5.27722473,11.0689437 C4.059712,12.0232419 2.52598109,12.5916201 0.859072,12.5916201 C0.572293818,12.5916201 0.288989091,12.5753082 0.0105483636,12.5423785 C1.58489018,13.5514839 3.454272,14.1402839 5.46346473,14.1402839 C12.0064,14.1405091 15.5845818,8.71982545 15.5845818,4.0192 Z', id: 'Shape', stroke: 'none', fill: '#FFFFFF', fillRule: 'evenodd' })
    ),
    _react2.default.createElement(
      'span',
      { className: 'connection-option-text' },
      'Twitter'
    )
  );
};

var GoogleIcon = function GoogleIcon() {
  return _react2.default.createElement(
    'div',
    { className: 'connection-option-item' },
    _react2.default.createElement(
      'svg',
      { width: '16px', height: '16px', viewBox: '0 0 16 16', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'g',
        { id: 'Group', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M15.68,8.18169492 C15.68,7.61457627 15.6291525,7.06881356 15.5345763,6.54542373 L8,6.54542373 L8,9.64 L12.3054237,9.64 C12.12,10.64 11.5562712,11.4871186 10.7091525,12.0545763 L10.7091525,14.0616949 L13.2945763,14.0616949 C14.8074576,12.6688136 15.68,10.6179661 15.68,8.18169492 L15.68,8.18169492 Z', id: 'Shape', fill: '#FFFFFF' }),
        _react2.default.createElement('path', { d: 'M8,16 C10.16,16 11.9708475,15.2837288 13.2945763,14.0616949 L10.7091525,12.0545763 C9.99288136,12.5345763 9.07627119,12.8183051 8,12.8183051 C5.91627119,12.8183051 4.15288136,11.4111864 3.52372881,9.52 L0.850847458,9.52 L0.850847458,11.5928814 C2.16711864,14.2074576 4.87254237,16 8,16 L8,16 Z', id: 'Shape', fill: '#FFFFFF' }),
        _react2.default.createElement('path', { d: 'M3.52372881,9.52 C3.36372881,9.04 3.27288136,8.52711864 3.27288136,8 C3.27288136,7.47288136 3.36372881,6.96 3.52372881,6.48 L3.52372881,4.40711864 L0.850847458,4.40711864 C0.309152542,5.48711864 0,6.70915254 0,8 C0,9.29084746 0.309152542,10.5128814 0.850847458,11.5928814 L3.52372881,9.52 L3.52372881,9.52 Z', id: 'Shape', fill: '#FFFFFF' }),
        _react2.default.createElement('path', { d: 'M8,3.18169492 C9.17457627,3.18169492 10.2291525,3.58542373 11.0583051,4.3779661 L13.3528814,2.08338983 C11.9671186,0.792881356 10.1562712,0 8,0 C4.87288136,0 2.16711864,1.79288136 0.850847458,4.40711864 L3.52372881,6.48 C4.15288136,4.58915254 5.91661017,3.18169492 8,3.18169492 Z', id: 'Shape', fill: '#FFFFFF' }),
        _react2.default.createElement('polygon', { id: 'Shape', points: '0 0 16 0 16 16 0 16' })
      )
    ),
    _react2.default.createElement(
      'span',
      { className: 'connection-option-text' },
      'Google'
    )
  );
};

var ConnectionOption = function (_Component) {
  _inherits(ConnectionOption, _Component);

  function ConnectionOption() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectionOption);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function (name, value) {
      _this.props.onChange('allowedConnections', value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectionOption.prototype.render = function render() {
    var value = this.props.value;

    var values = [{ value: 'facebook', label: _react2.default.createElement(FacebookIcon, null) }, { value: 'twitter', label: _react2.default.createElement(TwitterIcon, null) }, { value: 'google-oauth2', label: _react2.default.createElement(GoogleIcon, null) }, { value: 'Username-Password-Authentication', label: _react2.default.createElement(Auth0Icon, null), clearableValue: false }];

    return _react2.default.createElement(_components.MultiSelector, {
      arrowRenderer: function arrowRenderer() {
        return _react2.default.createElement(
          'span',
          { className: 'more-arrow' },
          '+'
        );
      },
      name: 'allowedConnections',
      onChange: this.onChange,
      options: values,
      value: value
    });
  };

  return ConnectionOption;
}(_react.Component);

ConnectionOption.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.array.isRequired
};
exports.default = ConnectionOption;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorOption = function EditorOption(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      defaultColor = _ref.defaultColor,
      logos = _ref.logos;

  switch (name) {
    case 'additionalSignUpFields':
      return _react2.default.createElement(_.AdditionalSignUpFieldsOption, { value: value, onChange: onChange });
    case 'allowLogin':
    case 'allowForgotPassword':
    case 'allowSignUp':
    case 'mustAcceptTerms':
      return _react2.default.createElement(_.BooleanOption, { name: name, value: value, onChange: onChange });
    case 'initialScreen':
      return _react2.default.createElement(_.InitialScreenOption, { value: value, onChange: onChange });
    case 'language':
      return _react2.default.createElement(_.LanguageOption, { value: value, onChange: onChange });
    case 'logo':
      return _react2.default.createElement(_.LogoOption, {
        value: value,
        logos: logos,
        onChange: onChange
      });
    case 'primaryColor':
      return _react2.default.createElement(_.ColorOption, {
        value: value,
        onChange: onChange,
        defaultColor: defaultColor
      });
    case 'allowedConnections':
      return _react2.default.createElement(_.ConnectionOption, { value: value, onChange: onChange });
    default:
      return _react2.default.createElement('span', null);
  }
};

EditorOption.propTypes = {
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  preset: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.any.isRequired,
  defaultColor: _propTypes2.default.string,
  logos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string.isRequired
  }).isRequired)
};

exports.default = EditorOption;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InitialScreenOption = function InitialScreenOption(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value;

  var values = [{ value: 'login', label: 'login' }, { value: 'signUp', label: 'signUp' }, { value: 'forgotPassword', label: 'forgotPassword' }];

  return _react2.default.createElement(
    'li',
    { className: 'line-row' },
    _react2.default.createElement(
      'span',
      null,
      'initialScreen:',
      _react2.default.createElement(_components.OptionSelector, {
        name: 'initialScreen',
        onChange: onChange,
        options: values,
        value: value
      })
    )
  );
};

InitialScreenOption.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired
};

exports.default = InitialScreenOption;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageDictionaryOption = function (_Component) {
  _inherits(LanguageDictionaryOption, _Component);

  function LanguageDictionaryOption(props) {
    _classCallCheck(this, LanguageDictionaryOption);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onChange = (0, _utils.debounce)(function (name, value) {
      var languageDictionary = (0, _utils.dup)(_this.props.value);
      languageDictionary[name] = value;
      _this.props.onChange('languageDictionary', languageDictionary);
    }, 400);
    return _this;
  }

  LanguageDictionaryOption.prototype.renderItem = function renderItem(name, value) {
    var _this2 = this;

    return _react2.default.createElement(
      'li',
      { className: 'line-row', key: name },
      _react2.default.createElement(
        'span',
        null,
        name,
        ':',
        _react2.default.createElement('input', {
          className: 'text-input',
          defaultValue: value,
          onChange: function onChange(e) {
            return _this2.onChange(name, e.target.value);
          }
        })
      )
    );
  };

  LanguageDictionaryOption.prototype.render = function render() {
    var _this3 = this;

    var value = this.props.value;


    return _react2.default.createElement(
      'div',
      { className: 'line-row' },
      _react2.default.createElement(
        'li',
        { className: 'line-row' },
        _react2.default.createElement(
          'span',
          null,
          'languageDictionary: ',
          '{'
        )
      ),
      global.Object.keys(value).map(function (k) {
        return _this3.renderItem(k, value[k]);
      }),
      _react2.default.createElement(
        'li',
        { className: 'line-row' },
        _react2.default.createElement(
          'span',
          null,
          '}'
        )
      )
    );
  };

  return LanguageDictionaryOption;
}(_react.Component);

LanguageDictionaryOption.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.object.isRequired
};
exports.default = LanguageDictionaryOption;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LanguageOption = function LanguageOption(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value;

  var values = [{ value: 'en', label: 'en', icon: 'https://cdn.auth0.com/website/playground/flags/en-flag.svg' }, { value: 'zh', label: 'zh', icon: 'https://cdn.auth0.com/website/playground/flags/zh-flag.svg' }, { value: 'ja', label: 'jp', icon: 'https://cdn.auth0.com/website/playground/flags/ja-flag.svg' }, { value: 'de', label: 'de', icon: 'https://cdn.auth0.com/website/playground/flags/de-flag.svg' }, { value: 'fr', label: 'fr', icon: 'https://cdn.auth0.com/website/playground/flags/fr-flag.svg' }, { value: 'es', label: 'es', icon: 'https://cdn.auth0.com/website/playground/flags/es-flag.svg' }, { value: 'it', label: 'it', icon: 'https://cdn.auth0.com/website/playground/flags/it-flag.svg' }, { value: 'pt-br', label: 'pt-br', icon: 'https://cdn.auth0.com/website/playground/flags/pt-br-flag.svg' }];

  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(_components.OptionSelector, {
      name: 'language',
      onChange: onChange,
      options: values,
      value: value
    }),
    _react2.default.createElement(
      'a',
      {
        className: 'see-all-languages',
        href: 'https://auth0.com/docs/libraries/lock/v10/i18n',
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      'See all Languages'
    )
  );
};

LanguageOption.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired
};

exports.default = LanguageOption;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoOption = function (_Component) {
  _inherits(LogoOption, _Component);

  function LogoOption() {
    var _temp, _this, _ret;

    _classCallCheck(this, LogoOption);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function (name, value) {
      _this.props.onChange('logo', value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LogoOption.prototype.render = function render() {
    var _props = this.props,
        value = _props.value,
        logos = _props.logos;


    var logoValues = logos || [{ value: 'default', label: 'default', icon: 'https://cdn.auth0.com/website/playground/others/auth0-default.svg' }, { value: 'logo-tmz.svg', label: 'logo-tmz.svg', icon: 'https://cdn.auth0.com/website/playground/others/logo-tmz.svg' }, { value: 'safari.svg', label: 'safari.svg', icon: 'https://cdn.auth0.com/website/playground/others/safari.svg' }, { value: 'schneider.svg', label: 'schneider.svg', icon: 'https://cdn.auth0.com/website/playground/others/schneider.svg' }];

    return _react2.default.createElement(_components.OptionSelector, {
      name: 'logo',
      onChange: this.onChange,
      options: logoValues,
      value: value
    });
  };

  return LogoOption;
}(_react.Component);

LogoOption.propTypes = {
  logos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string.isRequired
  }).isRequired),
  value: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired
};
exports.default = LogoOption;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialButtonStyle = function SocialButtonStyle(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value;

  var values = [{ value: 'small', label: 'small' }, { value: 'big', label: 'big' }];

  return _react2.default.createElement(
    'li',
    { className: 'line-row' },
    _react2.default.createElement(
      'span',
      null,
      'socialButtonStyle:',
      _react2.default.createElement(_components.OptionSelector, {
        name: 'socialButtonStyle',
        onChange: onChange,
        options: values,
        value: value
      })
    )
  );
};

SocialButtonStyle.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired
};

exports.default = SocialButtonStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = __webpack_require__(2);

var _2 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterLinks = function FooterLinks(_ref) {
  var optionsString = _ref.optionsString,
      docsUrl = _ref.docsUrl;
  return _react2.default.createElement(
    'ul',
    { className: 'footer-links' },
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        'a',
        { href: docsUrl, target: '_blank', rel: 'noopener noreferrer' },
        _react2.default.createElement(_2.ReadIcon, null),
        'Read the docs'
      )
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_.CodePenButton, { optionsString: optionsString })
    )
  );
};

FooterLinks.propTypes = {
  optionsString: _propTypes2.default.string.isRequired,
  docsUrl: _propTypes2.default.string.isRequired
};

exports.default = FooterLinks;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadIcon = function ReadIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "16px", height: "16px", viewBox: "0 0 16 16" },
    _react2.default.createElement("path", { stroke: "none", fill: "#FFFFFF", d: "M2,3.5 L0.5,3.5 L0.5,14 C0.5,14.825 1.175,15.5 2,15.5 L12.5,15.5 L12.5,14 L2,14 L2,3.5 L2,3.5 Z M14,0.5 L5,0.5 C4.175,0.5 3.5,1.175 3.5,2 L3.5,11 C3.5,11.825 4.175,12.5 5,12.5 L14,12.5 C14.825,12.5 15.5,11.825 15.5,11 L15.5,2 C15.5,1.175 14.825,0.5 14,0.5 L14,0.5 Z M13.25,7.25 L5.75,7.25 L5.75,5.75 L13.25,5.75 L13.25,7.25 L13.25,7.25 Z M10.25,10.25 L5.75,10.25 L5.75,8.75 L10.25,8.75 L10.25,10.25 L10.25,10.25 Z M13.25,4.25 L5.75,4.25 L5.75,2.75 L13.25,2.75 L13.25,4.25 L13.25,4.25 Z" })
  );
}; /* eslint-disable max-len */
exports.default = ReadIcon;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LanguageItem = function LanguageItem(_ref) {
  var text = _ref.text,
      image = _ref.image,
      index = _ref.index,
      active = _ref.active,
      handleClick = _ref.handleClick;
  return _react2.default.createElement(
    'li',
    {
      className: 'language-selector-item ' + (active ? 'active' : ''),
      onClick: function onClick() {
        return handleClick(index);
      }
    },
    _react2.default.createElement('img', { src: image, className: 'icon', role: 'presentation' }),
    _react2.default.createElement(
      'span',
      { className: 'text' },
      text
    )
  );
};

LanguageItem.propTypes = {
  text: _propTypes2.default.string.isRequired,
  image: _propTypes2.default.string.isRequired,
  active: _propTypes2.default.bool.isRequired,
  index: _propTypes2.default.number.isRequired,
  handleClick: _propTypes2.default.func.isRequired
};

var lockTypes = [{ text: 'Web', image: 'https://cdn.auth0.com/website/playground/platforms/lock-web-icon2.svg' }, { text: 'iOS', image: 'https://cdn.auth0.com/website/playground/platforms/lock-ios-icon.svg' }, { text: 'Android', image: 'https://cdn.auth0.com/website/playground/platforms/lock-android-icon.svg' }];

var LanguageSelector = function LanguageSelector(_ref2) {
  var selectedLanguageIndex = _ref2.selectedLanguageIndex,
      handleItemClick = _ref2.handleItemClick;
  return _react2.default.createElement(
    'div',
    { className: 'language-selector' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'ul',
        { className: 'language-selector-list' },
        lockTypes.map(function (type, index) {
          return _react2.default.createElement(LanguageItem, {
            key: type.text,
            text: type.text,
            image: type.image,
            index: index,
            active: index === selectedLanguageIndex,
            handleClick: handleItemClick
          });
        })
      )
    )
  );
};

LanguageSelector.propTypes = {
  selectedLanguageIndex: _propTypes2.default.number.isRequired,
  handleItemClick: _propTypes2.default.func.isRequired
};

exports.default = LanguageSelector;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _LanguageSelector = __webpack_require__(29);

var _LanguageSelector2 = _interopRequireDefault(_LanguageSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LanguageSelector2.default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(43);

var _components = __webpack_require__(2);

var _themePresets = __webpack_require__(33);

var _themePresets2 = _interopRequireDefault(_themePresets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockPlayground = function (_Component) {
  _inherits(LockPlayground, _Component);

  function LockPlayground() {
    var _temp, _this, _ret;

    _classCallCheck(this, LockPlayground);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      options: _themePresets2.default.login,
      preset: 'login',
      selectedLanguageIndex: 0
    }, _this.setPreset = function (name) {
      var options = _themePresets2.default[name];
      if (options) {
        _this.setState({ preset: name, options: options });
      }
    }, _this.setOption = function (name, value) {
      var options = _this.state.options.map(function (option) {
        var isName = option[0] === name;

        return isName ? [name, value] : option;
      });

      _this.setState({ options: options });
    }, _this.setSelectedType = function (index) {
      _this.setState({
        selectedLanguageIndex: index
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LockPlayground.prototype.render = function render() {
    var _props = this.props,
        defaultColor = _props.defaultColor,
        logos = _props.logos;
    var options = this.state.options;


    var themePresetOptions = _themePresets.themePreset.map(function (opt) {
      return opt[0];
    });

    var themeObj = ['theme', (0, _lodash.fromPairs)(options.filter(function (opt) {
      return themePresetOptions.includes(opt[0]);
    }))];

    var optionsWithTheme = options.filter(function (opt) {
      return !themePresetOptions.includes(opt[0]);
    }).concat([themeObj]);

    var optionsString = getOptionsString(optionsWithTheme, { defaultColor: defaultColor, logos: logos, logoBaseUrl: this.props.defaultsLogosBaseUrl });

    var optionsObj = getOptionsObj(optionsWithTheme, { defaultColor: defaultColor, logos: logos, logoBaseUrl: this.props.defaultsLogosBaseUrl });

    var preview = _react2.default.createElement(_components.Preview, {
      optionsString: optionsString,
      options: optionsObj,
      hideName: this.props.hideName
    });

    var editor = _react2.default.createElement(_components.Editor, {
      selectedLanguageIndex: this.state.selectedLanguageIndex,
      onOptionChange: this.setOption,
      options: this.state.options,
      preset: this.state.preset,
      logoBaseUrl: this.props.defaultsLogosBaseUrl,
      logos: this.props.logos,
      defaultColor: this.props.defaultColor,
      hideName: this.props.hideName,
      optionsString: optionsString
    });

    return _react2.default.createElement(
      'div',
      { className: 'lock-playground' },
      _react2.default.createElement(_components.LanguageSelector, {
        selectedLanguageIndex: this.state.selectedLanguageIndex,
        handleItemClick: this.setSelectedType
      }),
      _react2.default.createElement(
        'div',
        { className: 'editor-section' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-md-7' },
              editor
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-5 hidden-xs hidden-sm' },
              preview
            )
          )
        )
      )
    );
  };

  return LockPlayground;
}(_react.Component);

LockPlayground.propTypes = {
  defaultsLogosBaseUrl: _propTypes2.default.string,
  defaultColor: _propTypes2.default.string,
  logos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string.isRequired
  }).isRequired),
  hideName: _propTypes2.default.bool
};
LockPlayground.defaultProps = {
  defaultsLogosBaseUrl: 'https://cdn.auth0.com/website/playground/others/'
};
exports.default = LockPlayground;


function getOptionsString(options, _ref) {
  var defaultColor = _ref.defaultColor,
      logos = _ref.logos,
      logoBaseUrl = _ref.logoBaseUrl;

  return options.map(function (o) {
    if (o[0] === 'theme') {
      var value = {};

      if (o[1].logo !== 'default') {
        value.logo = (logoBaseUrl || '') + o[1].logo;
      } else if (logos) {
        value.logo = logos[0].icon;
      }

      if (o[1].primaryColor !== 'default') {
        value.primaryColor = o[1].primaryColor;
      } else if (defaultColor) {
        value.primaryColor = defaultColor;
      }

      return o[0] + ': ' + JSON.stringify(value);
    }

    return o[0] + ': ' + JSON.stringify(o[1]);
  }).join(',\n');
}

function getOptionsObj(options, _ref2) {
  var defaultColor = _ref2.defaultColor,
      logos = _ref2.logos,
      logoBaseUrl = _ref2.logoBaseUrl;

  return options.reduce(function (prev, curr) {
    if (curr[0] === 'theme') {
      prev.theme = {};

      if (curr[1].logo !== 'default') {
        prev.theme.logo = (logoBaseUrl || '') + curr[1].logo;
      } else if (logos) {
        prev.theme.logo = logos[0].icon;
      }

      if (curr[1].primaryColor !== 'default') {
        prev.theme.primaryColor = curr[1].primaryColor;
      } else if (defaultColor) {
        prev.theme.primaryColor = defaultColor;
      }
    } else {
      prev[curr[0]] = curr[1];
    }
    return prev;
  }, {});
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _LockPlayground = __webpack_require__(31);

var _LockPlayground2 = _interopRequireDefault(_LockPlayground);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LockPlayground2.default;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var themePreset = exports.themePreset = [['primaryColor', 'default'], ['logo', 'default']];
var languagePreset = ['language', 'en'];

var presets = {
  login: [['allowedConnections', ['Username-Password-Authentication', 'google-oauth2']], ['rememberLastLogin', false], ['socialButtonStyle', 'big']].concat(themePreset, [['languageDictionary', { title: 'Auth0' }], languagePreset])
};

exports.default = presets;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(9);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiSelector = function MultiSelector(_ref) {
  var name = _ref.name,
      _onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value,
      arrowRenderer = _ref.arrowRenderer;
  return _react2.default.createElement(
    'div',
    { className: 'option-selector ' + name },
    _react2.default.createElement(_reactSelect2.default, {
      autoBlur: true,
      name: name,
      value: value,
      options: options,
      onChange: function onChange(newObj) {
        _onChange(name, newObj.split(','));
      },
      multi: true,
      simpleValue: true,
      clearable: false,
      searchable: false,
      arrowRenderer: arrowRenderer
    })
  );
};

MultiSelector.propTypes = {
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.array.isRequired,
  value: _propTypes2.default.array.isRequired,
  arrowRenderer: _propTypes2.default.func
};

exports.default = MultiSelector;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _MultiSelector = __webpack_require__(34);

var _MultiSelector2 = _interopRequireDefault(_MultiSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MultiSelector2.default;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IcoOption = function IcoOption(_ref) {
  var onSelect = _ref.onSelect,
      onFocus = _ref.onFocus,
      isFocused = _ref.isFocused,
      option = _ref.option,
      className = _ref.className,
      children = _ref.children;

  var handleMouseDown = function handleMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    onSelect(option, event);
  };
  var handleMouseEnter = function handleMouseEnter(event) {
    onFocus(option, event);
  };
  var handleMouseMove = function handleMouseMove(event) {
    if (isFocused) return;
    onFocus(option, event);
  };
  var iconStyle = {
    width: 20,
    height: 15,
    borderRadius: '3px',
    marginRight: '8px'
  };
  var colorStyle = {
    width: 20,
    height: 15,
    backgroundColor: option.bg,
    display: 'inline-block',
    borderRadius: '3px',
    marginRight: '8px',
    position: 'relative',
    top: '2px'
  };

  var iconState = void 0;
  if (option.icon) {
    iconState = _react2.default.createElement('img', { src: option.icon, style: iconStyle, role: 'presentation' });
  } else if (option.bg) {
    iconState = _react2.default.createElement('span', { style: colorStyle });
  } else {
    iconState = '';
  }

  return _react2.default.createElement(
    'div',
    {
      className: className,
      onMouseDown: handleMouseDown,
      onMouseEnter: handleMouseEnter,
      onMouseMove: handleMouseMove
    },
    iconState,
    ' ',
    children
  );
};

IcoOption.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  isDisabled: _propTypes2.default.bool,
  isFocused: _propTypes2.default.bool,
  isSelected: _propTypes2.default.bool,
  onFocus: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  option: _propTypes2.default.object.isRequired
};

exports.default = IcoOption;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IcoValue = function IcoValue(_ref) {
  var value = _ref.value,
      children = _ref.children;

  var iconStyle = {
    width: 20,
    height: 15,
    borderRadius: '3px',
    marginRight: '8px'
  };
  var colorStyle = {
    width: 20,
    height: 15,
    backgroundColor: value.bg,
    display: 'inline-block',
    borderRadius: '3px',
    marginRight: '8px'
  };

  var iconState = void 0;
  if (value.icon) {
    iconState = _react2.default.createElement('img', { src: value.icon, style: iconStyle, role: 'presentation' });
  } else if (value.bg) {
    iconState = _react2.default.createElement('span', { style: colorStyle });
  } else {
    iconState = '';
  }

  return _react2.default.createElement(
    'div',
    { className: 'Select-value' },
    _react2.default.createElement(
      'span',
      { className: 'Select-value-label' },
      iconState,
      ' ',
      children
    )
  );
};

IcoValue.propTypes = {
  children: _propTypes2.default.node,
  value: _propTypes2.default.object
};

exports.default = IcoValue;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(9);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptionSelector = function OptionSelector(_ref) {
  var name = _ref.name,
      _onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value;
  return _react2.default.createElement(
    'div',
    { className: 'option-selector ' + name },
    _react2.default.createElement(_reactSelect2.default, {
      autoBlur: true,
      name: name,
      value: value,
      options: options,
      optionComponent: _.IcoOption,
      valueComponent: _.IcoValue,
      onChange: function onChange(newObj) {
        _onChange(name, newObj.value);
      },
      clearable: false,
      searchable: false
    })
  );
};

OptionSelector.propTypes = {
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.array.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]).isRequired
};

exports.default = OptionSelector;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iframeStyle = function iframeStyle(hideName) {
  return '\n<style>\n  html {\n    color: white;\n  }\n  body {\n    margin: 0;\n  }\n  .auth0-lock.auth0-lock .auth0-lock-center {\n    display: block !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  ' + (hideName ? '\n  .auth0-lock.auth0-lock .auth0-lock-header {\n    padding-top: 26px !important;\n  }\n  .auth0-lock.auth0-lock .auth0-lock-name {\n    display: none;\n  }\n  ' : '') + '\n</style>';
};

var Preview = function (_Component) {
  _inherits(Preview, _Component);

  function Preview() {
    var _temp, _this, _ret;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      screenMode: 'desktop',
      rendered: false
    }, _this.loadHtml = function () {
      // If the iframe element is not ready, don't try to write inside it
      if (!_this.desktopIframe) return;
      if (_this.state.rendered) {
        _this.desktopIframe.contentWindow.postMessage(_this.props.options, '*');
        return;
      }

      var html = '\n<head>\n  ' + iframeStyle(_this.props.hideName) + '\n</head>\n<body>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/lock.min.js"></script>\n\n  <div id="lock-desktop"></div>\n\n  <script>\n    var options = {\n      auth: {\n        redirect: false\n      },\n      container: "lock-desktop",\n      ' + _this.props.optionsString + '\n    }\n\n    var w = new Auth0Lock(\n      "7I3KXNi6ZeBq6oL0xnlfk1SrW6KntwR5",\n      "pwdlessdemo.auth0.com",\n      options\n    );\n\n    w.show();\n\n    w.on(\'authenticated\', function (authResult) {\n      setTimeout(function () {\n        w.hide();\n        w.show();\n      }, 3000);\n    });\n\n    window.addEventListener(\'message\', function (event) {\n      w.hide();\n      w.show(event.data);\n    }, false);\n  </script>\n\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/es.js"></script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/it.js"></script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/zh.js"></script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/fr.js"></script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/de.js"></script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/ja.js"></script>\n\n</body>';

      _this.desktopIframe.contentWindow.document.open();
      _this.desktopIframe.contentWindow.document.write(html);
      _this.desktopIframe.contentWindow.document.close();

      _this.setState({ rendered: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Preview.prototype.componentDidMount = function componentDidMount() {
    this.loadHtml();
  };

  Preview.prototype.componentDidUpdate = function componentDidUpdate() {
    this.loadHtml();
  };

  Preview.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(
      'div',
      { className: 'browser-web' },
      _react2.default.createElement('iframe', {
        className: 'iframe lock-iframe',
        ref: function ref(_ref) {
          _this2.desktopIframe = _ref;
        }
      })
    );
  };

  return Preview;
}(_react.Component);

Preview.propTypes = {
  optionsString: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.object.isRequired,
  hideName: _propTypes2.default.bool
};
exports.default = Preview;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _Preview = __webpack_require__(39);

var _Preview2 = _interopRequireDefault(_Preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Preview2.default;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

__webpack_require__(10);

var _components = __webpack_require__(2);

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _components2.default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;
exports.debounce = debounce;
exports.dup = dup;
function debounce(f, delay) {
  var t = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    function handler() {
      clearTimeout(t);
      f.apply(undefined, args);
    }
    clearTimeout(t);
    t = setTimeout(handler, delay);
  };
}

function copyProps(target) {
  for (var _len2 = arguments.length, srcs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    srcs[_key2 - 1] = arguments[_key2];
  }

  srcs.forEach(function (src) {
    global.Object.keys(src).forEach(function (k) {
      target[k] = src[k];
    });
  });
  return target;
}

function dup(obj) {
  return copyProps({}, obj);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// lock-playground.js


// WEBPACK FOOTER //
// webpack:///lock-playground.js